export const errors = {
  'Something went wrong': 'Qualcosa è andato storto',
  'Page not found': 'Pagina non trovata',
  'Go back home': 'Torna alla home',
};
